<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
        <div class="imp-class">
            <OutEntrepot :outEntrepotId="outEntrepotId"/>
        </div>

    </div>

    <div class="lct-class num1-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程历史跟踪
      </h3>
      <el-table :data="tableData" border>
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
        <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
        <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
        <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
      </el-table>
    </div>

    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 审批意见
        <div class="nr-class">
          <el-select v-model="queryParams.status" filterable placeholder="审批结果" clearable>
            <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p class="yjp-class">
            <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width:50%"></el-input>
          </p>
          <el-button type="primary" @click="submitFlowComment" style="margin-top: 20px;">提交</el-button>
        </div>
      </h3>
    </div>
  </div>

</template>
<script>
  import { processInstanceImage } from "@/api/api.js";//流程图
  import { historicActivityInstance } from "@/api/api.js";//记录展示
  import { outEntrepotDetailById,submitTask } from "@/api/api.js";//附加单据
  import OutEntrepot from "./info/OutEntrepot.vue";
  import webSocketService from '@/utils/WebSocketService';
  export default {
    name: "flowOutEntrepotAct",
    components: {OutEntrepot},
    data() {
      return{
        id: this.$route.query.id,
        processId: this.$route.query.processId,
        outEntrepotId: this.$route.query.id,
        str:"",
        formData: {},
        tableData:[],
        queryParams:{
          status: undefined,
          remark: undefined
        },
        source:[
          {
            value:1,
            label:"同意"
          },
          {
            value:2,
            label:"不同意"
          },
        ]
      }
    },
    methods: {
      submitFlowComment() {
        if (!this.queryParams.remark || !this.queryParams.status) {
          return this.$message.error("请输入审批内容或结果");
        }
        let params = {
          ...this.queryParams,
          processInstanceId: this.processId
        }
        params.outEntrepot = this.formData;
        submitTask(params).then(res => {
          if (res.data.code == 200) {
            this.$notify({
              title: '成功',
              message: '审批成功',
              type: 'success'
            });
            // 提交WebSocket消息主题
            this.submitWebSocketMessage();
            this.$store.dispatch('tagsView/delView', this.$route);
            this.$router.push({path: `/shipment/outEntrepot`});
            
          }
        })
      },
      //流程图，办理经过
      initData() {
        if (this.processId) {
          let params = {processInstanceId: this.processId};
          processInstanceImage(params).then(res => {
            this.str = res.data
          });
          historicActivityInstance(params).then(res => {
            if (res.data.code == 200) {
              this.tableData = res.data.data;
              this.tableData.map((item, index) => {
                item.ids = index + 1;
              })
            }
          });
        }

        outEntrepotDetailById({id: this.id}).then(res => {
            if (res.data.code == 200) {
                this.formData = res.data.data;
            }
        });
      },
      // 提交WebSocket消息主题
      submitWebSocketMessage() {
          //payload
          const message = {
              key:"entrepot",
              timestamp: Date.now(),
          };
          webSocketService.sendToTopic('/topic/entrepot', message);
      },

    },
    created() {},
    mounted() {
      this.initData()
    },
      watch: {
          '$route': {
              handler: function (to, from) {
                  if (to.name == "flowOutEntrepotAct" && (this.id != to.query.id)) {
                      this.processId =  this.$route.query.processId;
                      this.id =  this.$route.query.id;
                      this.outEntrepotId = this.$route.query.id;
                      this.initData();
                      this.queryParams = {
                          status: undefined,
                          remark: undefined
                      }
                  }
              },
              // 深度观察监听
              deep: true,
          },
      },
  };
</script>
<style scoped lang="less">
    .content {width: 98%}
    .imp-class{
        display: flex;
        justify-content: center;
    }

  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
  }

  .el-row {
    //   margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 0px;
    //   min-height: 36px;
    border: 1px solid #4d4d4d;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 46px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .grid-content-image {
    border-radius: 4px;
    min-height: 300px;
    padding: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  div.table-container {
    margin-top: 50px;
    margin-left: 220px;
    max-width: 1200px;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid black;
    table.table-layout {
      table-layout: fixed;
      border-collapse: collapse;
      width: 1080px;

      td.table-cell {
        display: table-cell;
        height: 36px;
        border: 1px solid black;
        text-align: center;
      }
    }
  }
  .table-checkbox,
  .table-radio {
    display: table-cell;
    border: 1px solid black;
    text-align: left;
  }

  .add-button {
    margin-top: -340px;
    margin-right: -10px;
    float: right;
    position: relative;
  }
  .save {
    margin-top: 50px;
    margin-left: 750px;
    position: relative;
  }
  .text-input {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
  }
  .text-input-left {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
  }
  .radio-input {
    vertical-align: middle;
    margin-top: -2px;
    margin-bottom: 1px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 138px;
    height: 138px;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .svg-avatar-uploader-icon {
    font-size: 28px;
    width: 60px;
    height: 60px;
    line-height: 18px;
    text-align: center;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 138px;
    height: 138px;
    // line-height: 88px;
    text-align: center;
  }
  .avatar {
    width: 138px;
    height: 138px;
    display: block;
  }

  .table-footer-info {
      margin-top: 6px;
      display: flex;
      gap: 120px;
  }
  .info-item {
      font-size: 18px;
  }
  .footer-info-item{
      font-size: 15px;
  }

  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
    .nr-class{
      margin-top: 20px;
      margin-left: 10px;
    }
    .yjp-class{
      margin-top: 20px;
    }
  }
</style>


